import { useState, useEffect } from 'react';

export const useProductFilters = (initialFilters = {}) => {
  const [filters, setFilters] = useState({
    category_id: initialFilters.category_id || '',
    seller_id: initialFilters.seller_id || '',
    min_price: initialFilters.min_price || '',
    max_price: initialFilters.max_price || '',
    search: initialFilters.search || '',
    is_featured: initialFilters.is_featured || '',
    ...initialFilters,
  });

  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  useEffect(() => {
    // Count active filters (excluding empty values)
    const count = Object.values(filters).filter(value => 
      value !== '' && value !== null && value !== undefined
    ).length;
    setActiveFiltersCount(count);
  }, [filters]);

  const updateFilter = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  const updateMultipleFilters = (newFilters) => {
    setFilters(prev => ({
      ...prev,
      ...newFilters,
    }));
  };

  const clearFilter = (key) => {
    setFilters(prev => ({
      ...prev,
      [key]: '',
    }));
  };

  const clearAllFilters = () => {
    setFilters({
      category_id: '',
      seller_id: '',
      min_price: '',
      max_price: '',
      search: '',
      is_featured: '',
    });
  };

  const getActiveFilters = () => {
    return Object.entries(filters)
      .filter(([_, value]) => value !== '' && value !== null && value !== undefined)
      .reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
      }), {});
  };

  return {
    filters,
    activeFiltersCount,
    updateFilter,
    updateMultipleFilters,
    clearFilter,
    clearAllFilters,
    getActiveFilters,
  };
};

export default useProductFilters;